import { render, staticRenderFns } from "./couponRule.vue?vue&type=template&id=dcf6f312&scoped=true"
import script from "./couponRule.vue?vue&type=script&lang=js"
export * from "./couponRule.vue?vue&type=script&lang=js"
import style0 from "./couponRule.vue?vue&type=style&index=0&id=dcf6f312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf6f312",
  null
  
)

export default component.exports